import { useModulePermission } from '../../../hooks/usePermission';
import { Modules } from '../../../constants/permissions';

/**
 * FIN_BillData module permission hook
 *
 * PgCode = "fin_billdata"
 * Permission format: fin_billdata_QUERY, fin_billdata_ADD, etc.
 */
export function useFinBillDataPermission() {
  return useModulePermission(Modules.FIN_BILLDATA);
}
